import type { TeamShowData } from '../../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { useCommonStore } from '@shared/model'
import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useTeamsStore } from '../../model/teams/store'

/**
 * `GET /admin-api/teams/{team}` — one team plus the active-user list for the member picker.
 */
export const useTeamApi = async (teamId: string | number): Promise<TeamShowData | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useTeamsStore()
  const commonStore = useCommonStore()

  const url = useAdminRoutes('admin.team.data', { team_id: teamId })

  commonStore.setLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    const showData: TeamShowData | null = data.data || null

    if (showData) {
      store.setCurrentTeam(showData.team)
      store.setUsers(showData.users)
    }

    return showData
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    commonStore.setLoading(false)
  }
}
